const KEY = "postLoginRedirect";

/** /youth 경로에서 로그인 화면으로 보낼 때만 저장한다. */
export const savePostLoginRedirect = (path: string) => {
  if (!path.startsWith("/youth")) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // sessionStorage 접근 실패 시 무시
  }
};

export const consumePostLoginRedirect = (): string | null => {
  try {
    const value = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return value && value.startsWith("/youth") ? value : null;
  } catch {
    return null;
  }
};
